import {GreenBoxNumber} from "../views/GreenBoxNumber";
import {formatToRandWithDecimalsString} from "../../core/helpers/textFormatting";
import React from "react";
import {IOrderBasketItem} from "../../core/interfaces/IOrderInfo";

export interface IViewMenuItemProps {
    menuItem: IOrderBasketItem,
}

export const ViewMenuItem = (props: IViewMenuItemProps) =>
{
    const legacyMenuItem = props.menuItem as any;
    const quantity = props.menuItem.quantity ?? legacyMenuItem.totalInBasket ?? 0;
    const lineTotal = props.menuItem.lineTotal ?? legacyMenuItem.price ?? 0;

    return(
        <div className='mx-4 my-2 bg-white rounded-2xl border border-slate-100 shadow-card overflow-hidden'>
            <div className='flex items-start p-4 gap-3'>

                {/* Badge */}
                {quantity !== 0 && (
                    <div className='flex-shrink-0 mt-0.5'>
                        <GreenBoxNumber value={quantity}/>
                    </div>
                )}

                {/* Text content */}
                <div className='flex flex-col flex-1 min-w-0'>
                    <span className='font-semibold text-slate-900 text-sm leading-snug'>
                        {props.menuItem.name}
                    </span>
                    <span className='text-sm font-semibold text-accent-green mt-1'>
                        {formatToRandWithDecimalsString(lineTotal)}
                    </span>
                    {props.menuItem.unitPrice != null && (
                        <span className='text-xs text-slate-500 mt-1'>
                            {quantity} × {formatToRandWithDecimalsString(props.menuItem.unitPrice)} each
                        </span>
                    )}
                    {(props.menuItem.selectedOptions ?? []).length > 0 &&
                        <span className='text-xs text-slate-400 mt-1.5 leading-relaxed'>
                            {(props.menuItem.selectedOptions ?? []).map(option => option.optionSetName && option.optionName
                                ? `${option.optionSetName}: ${option.optionName}`
                                : option.optionName
                            ).filter(Boolean).join(' · ')}
                        </span>
                    }
                    {props.menuItem.specialInstruction && (
                        <span className='text-xs text-slate-400 mt-1 italic'>
                            {props.menuItem.specialInstruction}
                        </span>
                    )}
                </div>

            </div>
        </div>
    )
}
